import React, { useEffect, useState } from 'react';

import IntegrationsSetupListItemSaveBcForm from './IntegrationsSetupListItemSaveBcForm';
import IntegrationsSetupListItemSaveXeroForm from './IntegrationsSetupListItemSaveXeroForm';

export default function IntegrationsSetupListItemCreateModal(props) {
    const [integrationCreated, setIntegrationCreated] = useState(false);
    const [request, setRequest] = useState(false);
    const [requestFailed, setRequestFailed] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        $('#create-integration').on('hidden.bs.modal', (e) => {
            internalCloseHandler();
        });
        return () => {
            $('#create-integration').off('hidden.bs.modal');
        };
    }, []);

    const cleanStates = () => {
        setRequest(false);
        setRequestFailed(false);
        setIntegrationCreated(false);
        setError(null);
    };

    const internalCloseHandler = () => {
        cleanStates();
        props.closeHandler();
    };

    const internalSuccessHandler = () => {
        cleanStates();
        props.successHandler();
    };

    return (
        <div className="modal fade" id="create-integration" tabIndex="-1" role="dialog" aria-labelledby="create-integration" aria-hidden="true">
            <div className="modal-dialog modal-sm text-center font-weight-bold" role="document">
                <div className="modal-content" style={{ minWidth: '600px' }}>
                    <div className="modal-header border-0">
                        <h5 className="modal-title text-blue">{$t('Integration with {{name}}', { name: props.provider.name })}</h5>
                    </div>
                    {!integrationCreated && (
                        <>
                            <div className="modal-body">
                                {props.componentName === 'IntegrationsSetupListItemSaveBcForm' && (
                                    <IntegrationsSetupListItemSaveBcForm
                                        integration={props.provider.integration}
                                        internalCloseHandler={internalCloseHandler}
                                        internalSuccessHandler={internalSuccessHandler}
                                        error={error}
                                        request={request}
                                        provider={props.provider}
                                        setIntegrationCreated={setIntegrationCreated}
                                        setRequest={setRequest}
                                        setRequestFailed={setRequestFailed}
                                        action={props.provider.integration ? 'update' : 'create'}
                                        storeUrl={props.storeUrl}
                                        updateUrl={props.updateUrl}
                                        testConnectionUrl={props.testConnectionUrl}
                                        setError={setError}
                                    />
                                )}
                                {props.componentName === 'IntegrationsSetupListItemSaveXeroForm' && (
                                    <IntegrationsSetupListItemSaveXeroForm
                                        integration={props.provider.integration}
                                        internalCloseHandler={internalCloseHandler}
                                        internalSuccessHandler={internalSuccessHandler}
                                        error={error}
                                        request={request}
                                        provider={props.provider}
                                        setIntegrationCreated={setIntegrationCreated}
                                        setRequest={setRequest}
                                        setRequestFailed={setRequestFailed}
                                        action={props.provider.integration ? 'update' : 'create'}
                                        storeUrl={props.storeUrl}
                                        updateUrl={props.updateUrl}
                                        testConnectionUrl={props.testConnectionUrl}
                                        setError={setError}
                                        initialStep={props.initialStep}
                                    />
                                )}
                                {!props.componentName && <></>}
                            </div>
                        </>
                    )}
                    {integrationCreated && (
                        <>
                            <div className="modal-body">
                                <div className="form-group row">
                                    <label className="col-sm-12 my-auto text-sm">{$t('Integration Configured')}</label>
                                </div>
                            </div>
                            <div className="modal-footer border-0 tw-justify-center">
                                <button type="button" className="button secondary" onClick={internalSuccessHandler}>
                                    {$t('Close')}
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
